
import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 tracking-wider text-sub" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          ご予約・お問い合わせ
        </h2>
        <p className="text-sm sm:text-base text-sub/80 leading-relaxed mb-8 sm:mb-12 max-w-2xl mx-auto">
          岡山市でヘアサロンをお探しの方、髪のお悩みをお持ちの方は、<br className="hidden sm:block" />お気軽にお問い合わせください。スタッフ一同、心よりお待ちしております。
        </p>

        <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-center mb-12">
          <a
            href="tel:086-012-3456"
            className="inline-flex items-center px-8 py-4 bg-primary text-white text-sm font-semibold rounded-full hover:bg-primary/90 transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer w-full sm:w-auto justify-center"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            <i className="ri-phone-line mr-2 w-5 h-5 flex items-center justify-center"></i>
            086-012-3456
          </a>
          <Link
            to="/contact"
            className="inline-flex items-center px-8 py-4 bg-transparent border-2 border-primary text-primary text-sm font-semibold rounded-full hover:bg-primary hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer w-full sm:w-auto justify-center"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            <i className="ri-mail-line mr-2 w-5 h-5 flex items-center justify-center"></i>
            お問い合わせフォーム
          </Link>
        </div>

        <div className="bg-accent/50 rounded-lg p-6 sm:p-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-left">
            <div>
              <h3 className="text-base sm:text-lg font-bold mb-3 flex items-center text-sub" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                <i className="ri-time-line mr-2 text-primary w-5 h-5 flex items-center justify-center"></i>
                営業時間
              </h3>
              <p className="text-sm text-sub/80">9:00 - 18:00</p>
              <p className="text-sm text-sub/80">定休日: 日曜日・祝日</p>
            </div>
            <div>
              <h3 className="text-base sm:text-lg font-bold mb-3 flex items-center text-sub" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                <i className="ri-map-pin-line mr-2 text-primary w-5 h-5 flex items-center justify-center"></i>
                アクセス
              </h3>
              <p className="text-sm text-sub/80">〒700-0000</p>
              <p className="text-sm text-sub/80">岡山市北区○○町1-2-3</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
